import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { initLenis, scrollToTarget, resetScroll } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const t1 = setTimeout(() => scrollToTarget(location.hash), 250);
      const t2 = setTimeout(() => scrollToTarget(location.hash, { immediate: true }), 900);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    resetScroll();
    const raf = requestAnimationFrame(() => resetScroll());
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = initLenis();
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-[#050505] text-white min-h-screen font-body">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coaching-vip" element={<Navigate to="/#coaching-vip" replace />} />
          <Route path="/contacto" element={<Navigate to="/#contacto" replace />} />
          <Route path="/preguntas-frecuentes" element={<Navigate to="/#faq" replace />} />
          <Route path="/aviso-legal" element={<Legal page="aviso-legal" />} />
          <Route path="/privacidad" element={<Legal page="privacidad" />} />
          <Route path="/cookies" element={<Legal page="cookies" />} />
          <Route path="/terminos-y-condiciones" element={<Legal page="terminos-y-condiciones" />} />
        </Routes>
        <Footer />
        <WhatsAppFab />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
